import { render, staticRenderFns } from "./viewparents.vue?vue&type=template&id=1202edaa&"
import script from "./viewparents.vue?vue&type=script&lang=js&"
export * from "./viewparents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports